import { userAgentEnrichmentPlugin } from '@amplitude/plugin-user-agent-enrichment-browser';

import { amplitudeClient } from './amplitudeClient';
import { getClientApp } from './getClientApp';
import { EventTypes } from './types';

const uaPlugin = userAgentEnrichmentPlugin({
  osName: true,
  osVersion: true,
  deviceManufacturer: false,
  deviceModel: false,
});

const initializeAmplitude = async (amplitudeUserData) => {
  try {
    if (!amplitudeUserData.public_id) {
      console.error('No public id, skipping amplitude initialization');
      return Promise.reject(new Error('No public id'));
    }
    amplitudeClient.setUserId(amplitudeUserData.public_id);
    amplitudeClient.add(uaPlugin);

    amplitudeUserData['client_app'] = getClientApp();
    amplitudeUserData['Version'] = window.APP_CONFIG.VERSION;

    // Set user properties
    const identify = new amplitudeClient.Identify();
    Object.keys(amplitudeUserData).forEach((key) => {
      identify.set(key, amplitudeUserData[key]);
    });
    amplitudeClient.identify(identify);

    console.log('Amplitude initialized');
    return Promise.resolve(true);
  } catch (err) {
    console.error('Failed to initialize amplitude', err);
    return Promise.reject(err);
  }
};

const sendTeacherAmplitudeEvent = (eventType: EventTypes, data = {}) => {
  try {
    if (__DEV__) {
      console.log(`Send Amplitude Event ${eventType}`);
      console.table(data);
    }
    amplitudeClient.track(eventType, data);
  } catch (err) {
    console.error('Failed to send amplitude event', err);
  }
};

const clearAmplitudeUserSession = () => {
  try {
    amplitudeClient?.setUserId(null);
  } catch (err) {
    console.error('Failed to clear amplitude session', err);
  }
};

export {
  initializeAmplitude,
  sendTeacherAmplitudeEvent,
  clearAmplitudeUserSession,
};
